/* eslint-disable no-unused-vars */
// TODO: Refactorizar para poder utilizar estos enums como tipado de variables
enum Functions {
  AppSettingRead = 'APP_SETTING_R',
  AppSettingUpdate = 'APP_SETTING_U',

  ReadTenantSetting = 'TENANT_SETTING_R',
  UpdateTenantSetting = 'TENANT_SETTING_U',

  CompanyCreate = 'COMPANY_C',
  CompanyDelete = 'COMPANY_D',
  CompanyGet = 'COMPANY_G',
  CompanyList = 'COMPANY_L',
  CompanyUpadate = 'COMPANY_U',

  OperationCreate = 'OPERATION_C',
  OperationDelete = 'OPERATION_D',
  OperationGet = 'OPERATION_G',
  OperationList = 'OPERATION_L',
  OperationUpdate = 'OPERATION_U',

  NoteRead = 'NOTE_R',
  NoteCreate = 'NOTE_C',
  NoteUpdate = 'NOTE_U',
  NoteDelete = 'NOTE_D',

  PlanRead = 'PLAN_R',
  PlanCreate = 'PLAN_C',
  PlanUpdate = 'PLAN_U',
  PlanDelete = 'PLAN_D',

  UserPlanRead = 'USER_PLAN_R',
  UserPlanCreate = 'USER_PLAN_C',
  UserPlanUpdate = 'USER_PLAN_U',
  UserPlanDelete = 'USER_PLAN_D',

  PermissionGet = 'PERMISSION_G',
  PermissionList = 'PERMISSION_L',
  PermissionUpdate = 'PERMISSION_U',

  RoleCreate = 'ROLE_C',
  RoleDelete = 'ROLE_D',
  RoleGet = 'ROLE_G',
  RoleList = 'ROLE_L',
  RoleUpdate = 'ROLE_U',
  RolePermissionCreate = 'ROLE_PERMISSION_C',
  RolePermissionGet = 'ROLE_PERMISSION_G',
  RolePermissionDelete = 'ROLE_PERMISSION_D',
  RolePermissionList = 'ROLE_PERMISSION_L',
  RolePermissionUpdate = 'ROLE_PERMISSION_U',

  AuditEventRead = 'AUDIT_EVENT_R',

  UserCreate = 'USER_C',
  UserCompanyGet = 'USER_COMPANY_G',
  UserCompanyList = 'USER_COMPANY_L',
  UserCompanyUpdate = 'USER_COMPANY_U',
  UserDelete = 'USER_D',
  UserGet = 'USER_G',
  UserList = 'USER_L',
  UserRoleGet = 'USER_ROLE_G',
  UserRoleList = 'USER_ROLE_L',
  UserRoleUpdate = 'USER_ROLE_U',
  UserUpdate = 'USER_U',

  UserProfileUpdate = 'USER_PROFILE_U',
  ProfilePictureCreate = 'PROFILE_PICTURE_C',
  ProfilePictureRead = 'PROFILE_PICTURE_R',
  ProfilePictureUpdate = 'PROFILE_PICTURE_U',
  ProfilePictureDelete = 'PROFILE_PICTURE_D',

  AdministrationMenuRead = 'ADMINISTRATION_MENU_R',

  ProductAdministrationMenuRead = 'PRODUCT_ADMIN_MENU_R',

  AccountAdministrationMenuRead = 'ACCOUNT_ADMIN_MENU_R',

  TenantRead = 'TENANT_R',
  TenantCreate = 'TENANT_C',
  TenantUpdate = 'TENANT_U',
  TenantDelete = 'TENANT_D',

  CreateTenantPicture = 'TENANT_PICTURE_C',
  ReadTenantPicture = 'TENANT_PICTURE_R',
  UpdateTenantPicture = 'TENANT_PICTURE_U',
  DeleteTenantPicture = 'TENANT_PICTURE_D',

  IgnoreMaintenanceMode = 'IGNORE_MAINTENANCE_MODE',

  IsAdmin = 'IS_ADMIN',
  IsStaffRole = 'IS_STAFF_ROLE',
  IsChair = 'IS_CHAIR_ROLE',
  IsPlatformRole = 'IS_PLATFORM_ROLE',
  AdvancedOrderDispatchmentAdministration = 'ADVANCED_ORDER_DISPATCH_ADMIN',

  TermsAndConditionsUpdate = 'TERMS_AND_CONDITIONS_U',

  CategoryRead = 'CATEGORY_R',
  CategoryCreate = 'CATEGORY_C',
  CategoryUpdate = 'CATEGORY_U',
  CategoryDelete = 'CATEGORY_D',

  ProgramCategoryRead = 'PROGRAM_CATEGORY_R',
  ProgramCategoryCreate = 'PROGRAM_CATEGORY_C',
  ProgramCategoryUpdate = 'PROGRAM_CATEGORY_U',
  ProgramCategoryDelete = 'PROGRAM_CATEGORY_D',

  ProgramRegionRead = 'PROGRAM_REGION_R',
  ProgramRegionCreate = 'PROGRAM_REGION_C',
  ProgramRegionUpdate = 'PROGRAM_REGION_U',
  ProgramRegionDelete = 'PROGRAM_REGION_D',

  ProductRead = 'PRODUCT_R',
  ProductCreate = 'PRODUCT_C',
  ProductUpdate = 'PRODUCT_U',
  ProductDelete = 'PRODUCT_D',

  StockMovementRead = 'STOCK_MOVEMENT_R',
  StockMovementCreate = 'STOCK_MOVEMENT_C',

  ProductLogRead = 'PRODUCT_LOG_R',
  UnlinkUser = 'USER_UNLINK',

  SettingAdministrationMenuRead = 'CONFIGURATION_ADMIN_MENU_R',

  ShopRead = 'SHOP_R',
  ShopCreate = 'SHOP_C',
  ShopUpdate = 'SHOP_U',
  ShopDelete = 'SHOP_D',

  OrderRead = 'ORDER_R',
  OrderCreate = 'ORDER_C',
  OrderUpdate = 'ORDER_U',
  OrderDelete = 'ORDER_D',
  OrderPaymentImport = 'ORDER_PAYMENT_IMPORT',

  SupplierRead = 'SUPPLIER_R',
  SupplierCreate = 'SUPPLIER_C',
  SupplierUpdate = 'SUPPLIER_U',
  SupplierDelete = 'SUPPLIER_D',

  WalletMovementRead = 'WALLET_MOVEMENT_R',
  WalletMovementCreate = 'WALLET_MOVEMENT_C',
  ReadWalletStats = 'WALLET_STATS_R',

  ReadShopList = 'SHOP_LIST_R',
  ReadTenantList = 'TENANT_LIST_R',

  OrderDispatchAdmin = 'ORDER_DISPATCH_ADMIN',

  SupplierMenuRead = 'SUPPLIER_MENU_R',
  DropshipperMenuRead = 'DROPSHIPPER_MENU_R',

  ScanDispatchPreparedOrder = 'SCAN_DISPATCH_PREPARED_ORDER',

  IsDropshipperRole = 'IS_DROPSHIPPER_ROLE',
  IsSupplierRole = 'IS_SUPPLIER_ROLE',

  crossdockingOrderR = 'CROSSDOCKING_ORDER_R',

  WalletRequestRead = 'WALLET_REQUEST_R',
  WalletRequestCreate = 'WALLET_REQUEST_C',
  WalletRequestManage = 'WALLET_REQUEST_M',

  OrderDetailScannedOrder = 'ORDER_DETAIL_SCANNED_ORDER',
  OrderLogList = 'ORDER_LOG_LIST',

  NotificationRead = 'NOTIFICATION_R',

  SurveyCampaignRead = 'SURVEY_CAMPAIGN_R',
  SurveyCampaignCreate = 'SURVEY_CAMPAIGN_C',

  ProgramRead = 'PROGRAM_R',
  ProvinceRead = 'PROVINCE_R',
  ProgramCreate = 'PROGRAM_C',
  ProgramUpdate = 'PROGRAM_U',
  ProgramDelete = 'PROGRAM_D',

  DashboardChairRead = 'DASHBOARD_CHAIR_R',
  ChairGuideRead = 'CHAIR_GUIDE_R',

  ExhibitionCategoryRead = 'EXHIBITION_CATEGORY_R',
  ExhibitionCategoryCreate = 'EXHIBITION_CATEGORY_C',
  ExhibitionCategoryUpdate = 'EXHIBITION_CATEGORY_U',
  ExhibitionCategoryDelete = 'EXHIBITION_CATEGORY_D',

  EventRead = 'EVENT_R',
  EventCreate = 'EVENT_C',
  EventUpdate = 'EVENT_U',
  EventDelete = 'EVENT_D',

  VCG_R = 'VCG_R',
  VCG_C = 'VCG_C',
  VCG_U = 'VCG_U',
  VCG_D = 'VCG_D',

  GroupCreate = 'GROUP_C',
  GroupRead = 'GROUP_R',
  GroupUpdate = 'GROUP_U',
  GroupDelete = 'GROUP_D',

  TaxConditionRead = 'TAX_CONDITION_R',
  TaxConditionCreate = 'TAX_CONDITION_C',
  TaxConditionUpdate = 'TAX_CONDITION_U',
  TaxConditionDelete = 'TAX_CONDITION_D',

  HitoTipoRead = 'HITO_TIPO_R',
  HitoTipoCreate = 'HITO_TIPO_C',
  HitoTipoUpdate = 'HITO_TIPO_U',
  HitoTipoDelete = 'HITO_TIPO_D',

  MemberHitoRead = 'MEMBER_HITO_R',
  MemberHitoCreate = 'MEMBER_HITO_C',
  MemberHitoUpdate = 'MEMBER_HITO_U',
  MemberHitoDelete = 'MEMBER_HITO_D',

  ContactCreate = 'CONTACT_C',
  ContactUpdate = 'CONTACT_U',
  ContactDelete = 'CONTACT_D',
  ContactGet = 'CONTACT_G',
  ContactList = 'CONTACT_L',

  ReadOpportunity = 'OPPORTUNITY_R',

  ContactLogRead = 'CONTACT_LOG_R',

  GroupLogRead = 'GROUP_LOG_R',

  ChairCreate = 'CHAIR_C',
  ChairUpdate = 'CHAIR_U',
  StaffCreate = 'STAFF_C',
  StaffUpdate = 'STAFF_U',
  ContactLogReadChair = 'CONTACT_LOG_R_CHAIR',
  GroupLogReadChair = 'GROUP_LOG_R_CHAIR',

  ExhibitorCreate = 'EXHIBITOR_C',
  ExhibitorRead = 'EXHIBITOR_R',
  ExhibitorUpdate = 'EXHIBITOR_U',
  ExhibitorDelete = 'EXHIBITOR_D',
  ExhibitorSelfRead = 'EXHIBITOR_SELF_R',
  ExhibitorSelfUpdate = 'EXHIBITOR_SELF_U',
  ExhibitorFeeChangeCreate = 'EXHIBITOR_FEE_CHANGE_C',
  ExhibitorFeeChangeCancel = 'EXHIBITOR_FEE_CHANGE_CANCEL',
  ExhibitorFeeChangeManage = 'EXHIBITOR_FEE_CHANGE_MANAGE',

  ExhibitorReviewCreate = 'EXHIBITOR_REVIEW_C',
  ExhibitorReviewRead = 'EXHIBITOR_REVIEW_R',

  ExhibitorBankDataRead = 'EXHIBITOR_BANK_DATA_R',
  ExhibitorBankDataUpdate = 'EXHIBITOR_BANK_DATA_U',

  TopicCreate = 'TOPIC_C',
  TopicRead = 'TOPIC_R',
  TopicUpdate = 'TOPIC_U',
  TopicDelete = 'TOPIC_D',
  TopicList = 'TOPIC_L',

  MeetingCreate = 'MEETING_C',
  MeetingRead = 'MEETING_R',
  MeetingUpdate = 'MEETING_U',
  MeetingDelete = 'MEETING_D',
  MeetingTopicUpdate = 'MEETING_TOPIC_U',

  PresentationCreate = 'PRESENTATION_C',
  PresentationRead = 'PRESENTATION_R',
  PresentationUpdate = 'PRESENTATION_U',
  PresentationDelete = 'PRESENTATION_D',
  PresentationCancel = 'PRESENTATION_CANCEL',
  PresentationSubmit = 'PRESENTATION_SUBMIT',
  PresentationLoadReceipts = 'PRESENTATION_LOAD_RECEIPTS',
  PresentationRegisterClose = 'PRESENTATION_REGISTER_CLOSE',
  PresentationRollbackBilling = 'PRESENTATION_ROLLBACK_BILLING',

  ProspectCreate = 'PROSPECT_C',
  ProspectRead = 'PROSPECT_R',
  ProspectUpdate = 'PROSPECT_U',
  ProspectUpdateStatus = 'PROSPECT_U_STATUS',
  ProspectDelete = 'PROSPECT_D',
  ProspectAssign = 'PROSPECT_ASSIGN',
  ProspectReassignmentCreate = 'PROSPECT_REASSIGNMENT_C',
  ProspectReassignmentRead = 'PROSPECT_REASSIGNMENT_R',
  ProspectReassignmentApprove = 'PROSPECT_REASSIGNMENT_APPROVE',
  ProspectReassignmentReject = 'PROSPECT_REASSIGNMENT_REJECT',
  ProspectFollowUpCreate = 'PROSPECT_FOLLOW_UP_C',
  ContactFollowUpCreate = 'CONTACT_FOLLOW_UP_C',

  EntryFormCreate = 'ENTRY_FORM_C',
  EntryFormRead = 'ENTRY_FORM_R',
  EntryFormUpdate = 'ENTRY_FORM_U',
  EntryFormUpdateStatus = 'ENTRY_FORM_STATUS_U',
  EntryFormDelete = 'ENTRY_FORM_D',

  RequestRead = 'REQUEST_R',
  RequestCreate = 'REQUEST_C',
  RequestDelete = 'REQUEST_D',
  RequestLogRead = 'REQUEST_LOG_R',
  RequestStatusUpdate = 'REQUEST_STATUS_U',
  RequestApprove = 'REQUEST_APPROVE',
  RequestReject = 'REQUEST_REJECT',
  RequestFinalize = 'REQUEST_FINALIZE',
  RequestReverse = 'REQUEST_REVERSE',
  RequestReasonRead = 'REQUEST_REASON_R',
  RequestStatusRead = 'REQUEST_STATUS_R',

  LeaveFormRead = 'LEAVE_FORM_R',
  LeaveFormCallRead = 'LEAVE_FORM_CALL_R',
  LeaveFormCallCreate = 'LEAVE_FORM_CALL_C',

  GroupFileCreate = 'GROUP_FILE_C',
  GroupFileRead = 'GROUP_FILE_R',
  GroupFileDelete = 'GROUP_FILE_D',

  ReportEmbedIndicatorsRead = 'REPORT_EMBED_INDICATORS_R',
  ReportEmbedReunionsRead = 'REPORT_EMBED_REUNIONS_R',
  ReportEmbedChairLoadRead = 'REPORT_EMBED_CHAIR_LOAD_R',
  ReportEmbedMembersRead = 'REPORT_EMBED_MEMBERS_R',
  ReportEmbedLicensesBonusesRead = 'REPORT_EMBED_LICENSES_BONUSES_R',
}

enum Features {
  Notes = 'NOTES',
}

/**
 * Numeric Types
 * Name	Storage Size	Range
 * smallint	2 bytes	-32768 to +32767
 * integer	4 bytes	-2147483648 to +2147483647
 * bigint	8 bytes	-9223372036854775808 to 9223372036854775807
 */
enum MaxLengthInputs {
  SystemUser_UserName = 40,
  SystemUser_Email = 100,
  StringInputs = 200,
  Phone = 100,
  CompanyPhone = 255,
  CompanyWebsite = 255,
  NumberInputs = 20,
  NumberInputsMaxInt = 2147483647,
  CodeSap = 4,
  Region_DeliveryTerm = 2,
  CategoryName = 50,
  CategoryDescription = 200,
  ProductName = 50,
  ProductDescription = 500,
  IncidentDescription = 600,
  ProductStock = 10,
  TenantName = 200,
  TenantCountry = 100,
  TenantCity = 100,
  ShopName = 250,
  ShopUrl = 200,
  FirstName = 100,
  LastName = 100,
  SupplierName = 100,
  SupplierFantasyName = 100,
  SupplierFisicalIdType = 50,
  SupplierFisicalId = 100,
  SupplierProductAddress = 200,
  CreateWalletRequestDescription = 600,
  InternalReference = 50,
  ReasonMaxCharacter = 600,
  ObservationMaxChars = 600,
  SupplierShipperName = 100,
  TagMaxChars = 25,
  OrderPaymentDetail = 100,
}

enum InputNumberMaxValues {
  DimensionsInputs = 9999,
}

export enum LocalStorageKeys {
  RoleSelected = 'role_selected',
  TranslationsVersions = 'translation_versions',
  Translations = 'translations',
  TwoFactorValidated = 'two_factor_validated',
  Token = 'token',
  UserId = 'userId',
  TrackedQueries = 'trackedQueries',
  optimisticValuesToReplace = 'optimisticValuesToReplace',
  TwoFAOmitted = 'TwoFAOmitted',
  LastTenantId = 'LastTenantId',
  googleImage = 'googleImage',
  OrdersFilter = 'orderFilter',
  OrdersOrder = 'orderOrder',
  BackUrlAfterLogin = 'backUrlAfterLogin',
  StoredFilters = 'storedFilters',
  StoredOrders = 'storedOrders',
  ForceReloadTranslationsFiles = 'forceReloadTranslationsFiles',
  CurrentSWETag = 'currentSWETag',
  PostInstallServiceWorker = 'postInstallServiceWorker',
  StoredPagination = 'storedPagination',
}

export enum screenWidth {
  w992 = 992,
  w768 = 768,
  w900 = 900,
}

export enum SystemLimits {
  //Se define limite de tamaño de archivos en bytes
  /*
    Recordar que este enum debe corresponder con el de backend.
  */

  MaxSizeOfFiles = 2000000, //20 MB,
}

export enum ErrorsStatusCode {
  userIsAlreadyValidatedCode = 64,
  recordNotFoundCode = 2,
  companyNameMatchFoundCode = 334,
}

export enum DefaultValues {
  Title = 'Vistage',
  TagColor = '#008800',
  AdministrationTagColor = '#ffaeae',
  ColorVistage = '#EDB700',
}

export enum SettingNames {
  RecoveryPasswordFrom = 'RECOVERY_PASSWORD_FROM',
  RecoveryPasswordSubject = 'RECOVERY_PASSWORD_SUBJECT',
  NodeMailerHost = 'NODEMAILER_HOST',
  NodeMailerPort = 'NODEMAILER_PORT',
  NodeMailerSecure = 'NODEMAILER_SECURE',
  NodeMailerUser = 'NODEMAILER_USER',
  NodeMailerPassword = 'NODEMAILER_PASSWORD',
  NodeMailerAccountType = 'NODEMAILER_ACCOUNT_TYPE',
  UrlSite = 'URL_SITE',
  PasswordRegex = 'PASSWORD_REGEX',
  ProfileRequired = 'PROFILE_REQUIRED',
  SecurityTokenExpiresin = 'SECURITY_TOKEN_EXPIRESIN',
  SecurityRefreshTokenExpiresin = 'SECURITY_REFRESH_TOKEN_EXPIRESIN',
  FirstLogin = 'FIRST_LOGIN',
  LimitMaxSizeFile = 'LIMIT_MAX_SIZE_FILE',
  GAClientID = 'GA_ID',
  ValidateUserByEmail = 'VALIDATE_USER_BY_EMAIL',
  UserPublicRegister = 'USERS_PUBLIC_REGISTER',
  PageTitle = 'PAGE_TITLE',
  MaintenanceMode = 'MAINTENANCE_MODE',
  MaintenanceModeMessage = 'MAINTENANCE_MODE_MESSAGE',
  AcceptTermsAndconditionsIsRequired = 'ACCEPT_TERMS_AND_CONDITIONS_IS_REQUIRED',
  FullNameMandatory = 'FULL_NAME_MANDATORY',
  TwoFactorAuthEnabled = 'TWO_FACTOR_AUTH_ENABLED',
  MultiTenant = 'MULTI_TENANT',
  UsernameRegex = 'USERNAME_REGEX',
  AccountCommissionPercentage = 'ACCOUNT_COMMISSION_PERCENTAGE',
  SupplierCommissionPercentage = 'SUPPLIER_COMMISSION_PERCENTAGE',
  AccountTransport = 'ACCOUNT_TRANSPORT',
  TrackingUrl = 'TRACKING_URL',
  VistageAccountHolder = 'VISTAGE_ACCOUNT_HOLDER',
  VistageAccountNumber = 'VISTAGE_ACCOUNT_NUMBER',
  VistageAccountCuit = 'VISTAGE_ACCOUNT_CUIT',
  VistageAccountCbu = 'VISTAGE_ACCOUNT_CBU',
  VistageAccountAlias = 'VISTAGE_ACCOUNT_ALIAS',
  WalletCashRetentionTime = 'WALLET_CASH_RETENTION_TIME',
  UrlVistageAppShopify = 'URL_VISTAGE_APP_SHOPIFY',
  ShippingPrice = 'SHIPPING_PRICE',
  ContactEmailTo = 'CONTACT_EMAIL_TO',
  CashOnDeliveryCommission = 'CASH_ON_DELIVERY_COMMISSION',
  contactLinkOnWhatsapp = 'CONTACT_LINK_ON_WHATSAPP',
  MaxItemsMultipleSelection = 'MAX_ITEMS_MULTIPLE_SELECTION',
  WalletRequestProcessingTime = 'WALLET_REQUEST_PROCESSING_TIME',
  UrlVistageAppTiendanube = 'URL_VISTAGE_APP_TIENDANUBE',
  MinWithdrawalAmount = 'MIN_WITHDRAWAL_AMOUNT',
  GroupBudgetUpdateMonth = 'GROUP_BUDGET_UPDATE_MONTH',
  GuideChairsUrl = 'GUIDE_CHAIRS_URL',
  GuideStaffUrl = 'GUIDE_STAFF_URL',
}

export enum PageKey {
  //Vistage Pages
  RedirectIfNotExist = 'redirectIfNotExist',
  DefaultRedirect = 'defaultRedirect',
  App = 'app',
  Home = 'home',
  GeneralDashboard = 'generalDashboard',
  Indicators = 'indicators',
  Reunions = 'reunions',
  ExhibitorReunions = 'exhibitorReunions',
  ChairReunions = 'chairReunions',
  ChairLoadPercentage = 'chairLoadPercentage',
  HelpDesk = 'helpDesk',
  ZohoDesk = 'zohoDesk',
  Board = 'board',
  BoardMembers = 'boardMembers',
  BoardReunions = 'boardReunions',
  CompleteDetail = 'completeDetail',
  Guides = 'guides',
  GuideChairs = 'guideChairs',
  GuideStaff = 'guideStaff',
  Role = 'role',
  Chair = 'chair',
  Exhibitor = 'exhibitor',
  ExhibitorFeeChangeRequests = 'exhibitorFeeChangeRequests',
  Meetings = 'meetings',
  Topics = 'topics',
  Presentations = 'presentations',
  MembersManagement = 'membersManagement',
  Members = 'members',
  Programs = 'programs',
  ProgramCategories = 'programCategories',
  ProgramVariants = 'programVariants',
  ProgramRegions = 'programRegions',
  ProgramsList = 'programList',
  UpdatePrices = 'updatePrices',
  UsaPrograms = 'usaPrograms',
  ConfigPrograms = 'configPrograms',
  Events = 'events',
  EventsList = 'eventsList',
  LandingEvent = 'landingEvent',
  Comunication = 'comunication',
  Groups = 'groups',
  GroupsPage = 'groupsPage',
  VCG = 'vcg',
  ExhibitorsSettings = 'exhibitorsSettings',
  ExhibitorsAdministration = 'exhibitorsAdministration',
  ExhibitorCategories = 'exhibitorCategories',
  ExhibitorSubcategories = 'exhibitorSubcategories',
  Hitos = 'hitos',
  HitoTipos = 'hitoTipos',
  HitoSubtipos = 'hitoSubtipos',
  People = 'people',
  Company = 'company',
  GroupsManagement = 'groupsManagement',
  membersChair = 'membersChair',
  myMembers = 'myMembers',
  myRequests = 'myRequests',
  Requests = 'requests',
  LeavePolls = 'leavePolls',

  Reports = 'reports',
  ReportDetail = 'reportDetail',

  Operation = 'operation',
  Config2fa = 'config2fa',
  LoginMethods = 'login Methods',
  Administration = 'administration',
  ProductAdministration = 'productAdministration',
  AccountAdministration = 'accountAdministration',
  TenantSetting = 'tenant setting',
  Permission = 'permission',
  Audit = 'audit',
  Tenant = 'tenant',
  User = 'user',
  ManageTermsAndConditions = 'manageTermsAndConditions',
  TermsAndConditionsForAdmin = 'termsAndConditionsForAdmin',
  Setting = 'setting',
  About = 'about',
  Profile = 'profile',
  CheckCompany = 'checkCompany',
  Contact = 'contact',
  Status = 'status',
  PublicLayout = 'publicLayout',
  ResetPassword = 'resetPassword',
  SetPassword = 'setPassword',
  CompleteRegister = 'completeRegister',
  TermsAndConditions = 'termsAndConditions',
  Login = 'login',
  Register = 'register',
  Generate = 'generate',
  Reminder = 'reminder',
  ValidateTotp = 'validateTotp',
  Maintenance = 'maintenance',
  Invitations = 'invitations',
  Invitation = 'invitation',
  SelectTenant = 'selectTenant',
  MustChangePassword = 'mustChangePassword',
  // Categories = 'categories',
  Products = 'products',
  ProductHistory = 'productHistory',
  MyAccount = 'myAccount',
  MyExhibitorProfile = 'myExhibitorProfile',
  SettingAdminstration = 'settingAdministration',
  Connections = 'connections',
  Orders = 'orders',
  Suppliers = 'suppliers',
  Wallet = 'wallet',
  NewProduct = 'newProduct',
  UpdateProduct = 'updateProduct',
  Supplier = 'supplier',
  SupplierOrders = 'supplierOrders',
  SupplierProducts = 'supplierProducts',
  SupplierOrderDetail = 'supplierOrderDetail',
  NewExhibitor = 'newExhibitor',
  UpdateExhibitor = 'updateExhibitor',
  Dropshipper = 'dropshipper',

  WalletMovements = 'walletMovements',
  WalletRequests = 'walletRequests',
  ResendConfirmationAccountEmailPage = 'resendConfirmationAccountEmail',
  SupplierOrdersLogs = 'supplierOrdersLogs',
  DropshipperOrdersLogs = 'dropshipperOrdersLogs',
  OrderPaymentPage = 'orderPayment',
  Notifications = 'notifications',
  SupplierProductDetail = 'supplierProductDetail',
  EntryForm = 'entryForm',
  EntryFormList = 'entryFormList',
  EntryFormPending = 'entryFormPending',
  TaxCondition = 'taxCondition',

  Opportunities = 'opportunities',
  Community = 'community',
  CommunityContacts = 'communityContacts',
  CommunityStaff = 'communityStaff',
  CommunityChair = 'communityChair',
  CommunityMembers = 'communityMembers',
  CommunityProspect = 'communityProspect',
  Prospection = 'prospection',
  ContactLog = 'contactLog',
  GroupLog = 'groupLog',
  ContactLogChair = 'contactLogChair',
  GroupLogChair = 'groupLogChair',
  ExhibitorFormPage = 'exhibitorFormPage',
  ExternalPresenterInvoiceFormPage = 'externalPresenterInvoiceFormPage',

  Surveys = 'surveys',
  SurveyCampaigns = 'surveyCampaigns',
  EntryFormPublicPage = 'entryFormPublicPage',
  EvaluationForm = 'evaluationForm',
  EvaluationResults = 'evaluationResults',
}

export enum TenantSettingNames {
  Allow_delete_company = 'ALLOW_DELETE_COMPANY',
}

export enum SettingBooleanString {
  True = 'true',
  False = 'false',
}

/* Recordar: si se quiere agregar un nuevo object store hay que realizar la declaracion correspondiente en el archivo IndexedDb.ts */
export enum ObjectStore {
  Company = 'companies',
  PostponedActions = 'postponedActions',
  Operation = 'operations',
  Tag = 'tags',
}

export enum ExportFormat {
  xlsx = 'xlsx',
  csv = 'csv',
  txt = 'txt',
}

export enum Themes {
  DEFAULT = 'light',
  LIGHT = 'light',
  DARK = 'dark',
}

export enum LoginProviders {
  GOOGLE = 'google.com',
  PHONE = 'phone',
  MICROSOFT = 'microsoft.com',
}

enum TermsAndConditionsStatus {
  Active = 1,
  Inactive = 2,
}

enum FormatsManageTermsAndConditions {
  Html = 'HTML',
}

enum IsActiveId {
  Active = 1,
  Inactive = 2,
}
enum MimeTypes {
  imagesPng = 'image/png',
  imagesJpg = 'image/jpg',
  imagesJpeg = 'image/jpeg',
  imagesWebp = 'image/webp',
  applicationPdf = 'application/pdf',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

enum Roles {
  Admin = 1,
  User = 2,
  AdminTenant = 3,
}

enum StockReasonType {
  Initial = 1,
  Addition = 2,
  Removal = 3,
}

enum SystemTenantsNames {
  SystemTenant = 'systemTenant',
}

enum SystemTenantsIds {
  SystemTenant = 1,
}

enum RoleTypes {
  Admin = 1,
  Chair = 2,
  Expositor = 3,
  Staff = 4,
  Member = 5,
  Prospect = 6,
}

enum ShopConnectionStatus {
  Pending = 1,
  Connected = 2,
  Disconnected = 3,
}

//TODO: Quitar cuando el filtro de tipo de pago se quite de conexiones
enum ShopPaymentType {
  CashOnDelivery = 1,
  PrePaid = 2,
}

enum OrderPaymentType {
  CashOnDelivery = 1,
  PrePaid = 2,
}

enum TabsKeys {
  All = 'all',
  WalletTabsMovements = 'movements',
  WalletTabsSummary = 'summary',
  Dropshipper = 'dropshipper',
  Supplier = 'supplier',
}

export enum OrderActionNames {
  Update = 'update',
  SolicitRevision = 'solicitRevision',
  Delete = 'delete',
  Cancel = 'cancel',
  Confirm = 'confirm',
  Reject = 'reject',
  RegisterPayment = 'registerPayment',
  GenerateTrackingCode = 'generateTrackingCode',
  GenerateTicket = 'generateTicket',
  RegisterDispatch = 'registerDispatch',
  LabelDelivered = 'labelDelivered',
  LabelReturned = 'labelReturned',
  PrintTicket = 'printTicket',
  CancelTrackingCode = 'cancelTrackingCode',
  DeleteTicket = 'deleteTicket',
  RegisterIncident = 'registerIncident',
  RevertStatus = 'revertStatus',
  RequestCancellation = 'requestCancellation',
  FinalizeRevision = 'finalizeRevision',
  EditDeliveryAddress = 'editDeliveryAddress',
  EndIncident = 'endIncident',
  LabelPrepared = 'labelPrepared',
  ReturnStock = 'returnStock',
  AddOrderLine = 'addOrderLine',
  EditPaymentType = 'editPaymentType',
  EditPaymentStatus = 'editPaymentStatus',
}

enum ActionsLevels {
  WithoutLevel = 0,
  Primary = 1,
  Default = 2,
  Text = 3,
}

enum TicketStatus {
  NotGenerated = 0,
  Generated = 1,
  OrderHaveTrackingCodeNotTicket = 3,
}

enum KeysToReplaceInStrings {
  TrackingCodeInUrl = 'space_to_insert_code',
  ClientIdInTrackingUrl = 'space_to_insert_client_id',
}

enum WalletReasonType {
  Addition = 2,
  Removal = 3,
}

enum SearchParamsKey {
  ConfigBankAccountInformation = 'configBankAccountInformation',
}

enum OrderStats {
  CanceledAmount = 'canceled_amount',
  ConfirmedAmount = 'confirmed_amount',
  DeliveredAmount = 'delivered_amount',
  DispatchedAmount = 'dispatched_amount',
  PendingAmount = 'pending_amount',
  RejectedAmount = 'rejected_amount',
  ReturnedAmount = 'returned_amount',
}

enum OrderStatusesNames {
  Pending = 'Pendiente',
  InRevision = 'En revisión',
  AwaitingPayment = 'A pagar',
  Confirmed = 'Confirmado',
  Dispatched = 'Despachado',
  Delivered = 'Entregado',
  Returned = 'Devuelto',
  Canceled = 'Cancelado',
  Draft = 'Borrador',
  Rejected = 'Rechazado',
  Prepared = 'Preparado',
  WithIncident = 'Con incidencias',
}

enum PagesThatStoreFiltersAndOrder {
  Order = 'order',
  SupplierOrder = 'supplierOrder',
  Product = 'product',
  Connection = 'connection',
  Wallet = 'wallet',
  SupplierProduct = 'supplierProduct',
  WalletRequests = 'walletRequests',
  DropshipperOrderLogs = 'dropshipperOrderLogs',
  SupplierOrderLogs = 'supplierOrderLogs',
  DropshipperOrderDetail = 'dropshipperOrderDetail',
  SupplierOrderDetail = 'dropshipperOrderDetail',
  Notifications = 'notifications',
  ContactLog = 'contactLog',
  GroupLog = 'groupLog',
  GroupsPage = 'groupsPage',
  Exhibitors = 'exhibitors',
  MembersPage = 'membersPage',
  Topics = 'topics',
  Presentations = 'presentations',
  Meetings = 'meetings',
}

enum RadioButtonSelectorProductTypesValues {
  UniqueProduct = 'unique',
  ProductsWithVariants = 'variants',
}

enum OrderPaymentReceptionStatus {
  Pending = 0,
  Complete = 1,
  Partial = 2,
}

enum AccountType {
  Dropshipper = 1,
  Supplier = 2,
  Administrator = 3,
}

enum AccountStatus {
  Active = 1,
  Inactive = 0,
}

enum OrdersPageMode {
  Dropshipper = 'dropshipper',
  Supplier = 'supplier',
}

enum OrderDetailPageMode {
  Dropshipper = 'dropshipper',
  Supplier = 'supplier',
}

enum OrdersLogsPageMode {
  Dropshipper = 'dropshipper',
  Supplier = 'supplier',
}
enum SupplierStatus {
  Inactive = 0,
  Active = 1,
}

enum SupplierLogisticService {
  Crossdocking = 'crossdocking',
  Warehousing = 'warehousing',
}

enum LogisticMode {
  Crossdocking = 1,
  Warehousing = 2,
}

enum IdentificationTypeSelectValue {
  DNI = 'DNI',
  CUIT = 'CUIT',
}

enum IdentificationType {
  DNI = 1,
  CUIT = 2,
}

enum ChairAccountStatus {
  Inactive = 0,
  Active = 1,
  Pending = 2,
}

enum ExhibitorAccountStatus {
  Inactive = 0,
  Active = 1,
}

enum OperationAccountInfoMode {
  ExhibitorAccountRequest = 'exhibitorAccountRequest',
  ChairAccountRequest = 'chairAccountRequest',
  CancellationChairAccountRequest = 'cancellationChairAccountRequest',
  CancellationExhibitorAccountRequest = 'cancellationExhibitorAccountRequest',
}

enum ExportKeys {
  Orders = 'orders',
  Movements = 'movements',
}

enum WalletRequestType {
  Deposit = 2,
  Withdrawal = 3,
}

enum WalletRequestStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
}

enum Token2FA {
  CodeLength = 6,
}

enum Language {
  English = 1,
  Spanish = 2,
  Default = Spanish,
}
enum CountryDefault {
  CountryDefault = 'Argentina',
  CountryCodeDefault = '54',
}
enum LogActionType {
  Admin = 1,
  Chair = 2,
  Expositor = 3,
  Staff = 4,
  Member = 5,
  Contact = 6,
  Group = 7,
  Prospect = 8,
}
enum OrderLogisticState {
  NotDispatched = 0,
  Prepared = 1,
  Dispatched = 2,
}

enum ShopConnectionType {
  Shopify = 1,
  Tiendanube = 2,
}

enum ContainerId {
  Billing = 'billing',
}

enum NavePaymentStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED',
  Refunded = 'REFUNDED',
}

enum SettingsDefaultValues {
  MinWithdrawalAmount = 50000,
}

enum OrderPaymentStatusEnum {
  Pending = 1,
  Complete = 2,
  Canceled = 3,
  Returned = 4,
  NotFound = 5,
}

enum ProductStatusesNames {
  Draft = 'Borrador',
  InRevision = 'En revisión',
  Approved = 'Aprobado',
  Rejected = 'Rechazado',
}

enum ProductStatusesIds {
  Draft = 1,
  InRevision = 2,
  Approved = 3,
  Rejected = 4,
}

export enum ProductActionsNames {
  Edit = 'edit',
  Duplicate = 'duplicate',
  RequestReview = 'requestReview',
  Delete = 'delete',
  RequestAdjustments = 'requestAdjustments',
  ToggleStatus = 'toggleStatus',
  CreateNewVersion = 'createNewVersion',
  ViewHistory = 'viewHistory',
  ModifyStock = 'modifyStock',
  View = 'view',
  ReivewApprove = 'reviewApprove',
  ReviewReject = 'reviewReject',
}

export enum ProductDetailContentMode {
  Dropshipper = 'dropshipper',
  Supplier = 'supplier',
}

export enum ConstNumbers {
  Zero = 0,
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Six = 6,
  Seven = 7,
  Eight = 8,
  Nine = 9,
  Ten = 10,
}

export enum CategoriaHito {
  RECONOCIMIENTO = 'RECONOCIMIENTO',
  BENEFICIO = 'BENEFICIO',
  LABORAL = 'LABORAL',
  OTRO = 'OTRO',
}

export enum VigenciaTipo {
  SIN_VIGENCIA = 'SIN_VIGENCIA',
  MES_DESDE = 'MES_DESDE',
  RANGO_MESES = 'RANGO_MESES',
  FECHA = 'FECHA',
  RANGO_FECHAS = 'RANGO_FECHAS',
}

export enum ImpactoTipo {
  SIN_IMPACTO = 'SIN_IMPACTO',
  PORCENTAJE = 'PORCENTAJE',
}

export enum ContactCountry {
  Argentina = 'Argentina',
}

export enum ExhibitorFileAction {
  Keep = 'Keep',
  Replace = 'Replace',
}

export enum ProgramVariantScope {
  GroupScope = 1,
  MemberScope = 2,
}

export enum ReferredByType {
  Chair = 'chair',
  Member = 'member',
  Event = 'event',
  Counselor = 'counselor',
  Other = 'other',
  Lead = 'lead',
}

export enum PaymentType {
  BankDebit = 'Débito bancario',
  CreditCardDebit = 'Débito tarjeta de crédito',
}

export enum ContactGender {
  Male = 'Masculino',
  Female = 'Femenino',
  Other = 'Otro',
}

// Mapeo de género: texto a número (para enviar al backend)
export const ContactGenderToNumber: Record<string, number> = {
  Masculino: 1,
  Femenino: 2,
  Otro: 3,
};

// Mapeo de género: número a texto (para mostrar en el frontend)
export const ContactGenderFromNumber: Record<number, string> = {
  1: 'Masculino',
  2: 'Femenino',
  3: 'Otro',
};

export enum MemberLeaveReason {
  AumentoDeCuota = 'Aumento de cuota',
  CambioDeMiembroDeLaMismaEmpresa = 'Cambio de miembro de la misma empresa',
  CambioPosicionEnLaEmpresa = 'Cambio posición en la empresa',
  CierreDeEmpresaVentaDeLaEmpresa = 'Cierre/Venta de la empresa',
  DesvinculadoRenuncia = 'Desvinculado/Renuncia',
  Fallecido = 'Fallecido',
  FaltaDeTiempoParaAsistirALasReuniones = 'Falta de tiempo para asistir a las reuniones',
  Jubilacion = 'Jubilación',
  LaEmpresaNoPagaMásLaMembresia = 'La empresa no paga más la membresía',
  MudanzaSeAFueLaVivirAOtroPais = 'Mudanza/se fue a vivir a otro país',
  NoTeniaFeelingConElChair = 'No tenía feeling con el Chair',
  ProblemasEconomicos = 'Problemas económicos',
  ProblemasPersonalesSalud = 'Problemas personales/Salud',
  RelacionConElGrupo = 'Relación con el grupo',
  SienteQueCumplioUnCiclo = 'Siente que cumplió un ciclo',
  SuManejoDelGrupo = 'El manejo del Grupo',
  NoMeSentiaAcompanadoConSeguimientoEnMisDesafios = 'No se sentía acompañado y con seguimiento en sus desafíos (reuniones individuales)',
  OrganizacionDeLasReunionesGrupalesEIndividuales = 'Organización de las reuniones grupales e individuales (puntualidad y temas relevantes)',
  CantidadCalidadDeMiembros = 'Cantidad y/o calidad de Miembros',
  CalidadDeLosTemasTratadosEnLaReunionGrupal = 'Calidad de los temas tratados en la Reunión Grupal',
  CalidadDeLosExpositoresQueVenianALasRGs = 'Calidad de los Expositores que venían a las RGs',
  NoMeLlevabaBuenosAportesQueMeAyudenACrecer = 'No se llevaba buenos aportes que le ayuden a crecer',
  NoMeSentiaDesafiadoPorMiGrupoChair = 'No se sentía desafiado por su Grupo/Chair',
  Virtualidad = 'Virtualidad',
  LaCalidadDeContenidos = 'La calidad de contenidos (webinars, plataformas)',
  Otra = 'Otra',
  NoLlamar = 'No llamar',
  NoContesta = 'No contesta',
  CambioDeGrupo = 'Cambio de grupo',
}

export class EnumsValues {
  static readonly Functions = Functions;

  readonly Functions = EnumsValues.Functions;

  static readonly Features = Features;

  readonly Features = EnumsValues.Features;

  static readonly MaxLengthInputs = MaxLengthInputs;

  readonly MaxLengthInputs = EnumsValues.MaxLengthInputs;

  static readonly LocalStorageKeys = LocalStorageKeys;

  readonly LocalStorageKeys = EnumsValues.LocalStorageKeys;

  static readonly SettingNames = SettingNames;

  readonly SettingNames = EnumsValues.SettingNames;

  static readonly SystemLimits = SystemLimits;

  readonly SystemLimits = EnumsValues.SystemLimits;

  static readonly ErrorsStatusCode = ErrorsStatusCode;

  readonly ErrorsStatusCode = EnumsValues.ErrorsStatusCode;

  static readonly DefaultValues = DefaultValues;

  readonly DefaultValues = EnumsValues.DefaultValues;

  static readonly Themes = Themes;

  readonly Themes = EnumsValues.Themes;

  static readonly LoginProviders = LoginProviders;

  readonly LoginProviders = EnumsValues.LoginProviders;

  static readonly TermsAndConditionsStatus = TermsAndConditionsStatus;

  readonly TermsAndConditionsStatus = EnumsValues.TermsAndConditionsStatus;

  static readonly FormatsManageTermsAndConditions =
    FormatsManageTermsAndConditions;

  readonly FormatsManageTermsAndConditions =
    EnumsValues.FormatsManageTermsAndConditions;

  static readonly IsActiveId = IsActiveId;

  readonly IsActiveId = EnumsValues.IsActiveId;

  static readonly MimeTypes = MimeTypes;

  readonly MimeTypes = EnumsValues.MimeTypes;

  static readonly Roles = Roles;

  readonly Roles = EnumsValues.Roles;

  static readonly InputNumberMaxValues = InputNumberMaxValues;

  readonly InputNumberMaxValues = EnumsValues.InputNumberMaxValues;

  static readonly StockReasonType = StockReasonType;

  readonly StockReasonType = EnumsValues.StockReasonType;

  static readonly SystemTenantsNames = SystemTenantsNames;

  readonly SystemTenantsNames = EnumsValues.SystemTenantsNames;

  static readonly RoleTypes = RoleTypes;

  readonly RoleTypes = EnumsValues.RoleTypes;

  static readonly SystemTenantsIds = SystemTenantsIds;

  readonly SystemTenantsIds = EnumsValues.SystemTenantsIds;

  static readonly ShopConnectionStatus = ShopConnectionStatus;

  readonly ShopConnectionStatus = EnumsValues.ShopConnectionStatus;

  //TODO: Quitar cuando el filtro de tipo de pago se quite de conexiones
  static readonly ShopPaymentType = ShopPaymentType;
  //TODO: Quitar cuando el filtro de tipo de pago se quite de conexiones
  readonly ShopPaymentType = EnumsValues.ShopPaymentType;

  static readonly TabsKeys = TabsKeys;

  readonly TabsKeys = EnumsValues.TabsKeys;

  static readonly OrderActionNames = OrderActionNames;

  readonly OrderActionNames = EnumsValues.OrderActionNames;

  static readonly KeysToReplaceInStrings = KeysToReplaceInStrings;

  readonly KeysToReplaceInStrings = EnumsValues.KeysToReplaceInStrings;

  static readonly TicketStatus = TicketStatus;

  readonly TicketStatus = EnumsValues.TicketStatus;

  static readonly WalletReasonType = WalletReasonType;

  readonly WalletReasonType = EnumsValues.WalletReasonType;

  static readonly SearchParamsKey = SearchParamsKey;

  readonly SearchParamsKey = EnumsValues.SearchParamsKey;

  static readonly OrderStats = OrderStats;

  readonly OrderStats = EnumsValues.OrderStats;

  static readonly OrderStatusesNames = OrderStatusesNames;

  readonly OrderStatusesNames = EnumsValues.OrderStatusesNames;

  static readonly PagesThatStoreFiltersAndOrder = PagesThatStoreFiltersAndOrder;

  readonly PagesThatStoreFiltersAndOrder =
    EnumsValues.PagesThatStoreFiltersAndOrder;

  static readonly ActionsLevels = ActionsLevels;

  readonly ActionsLevels = EnumsValues.ActionsLevels;

  static readonly RadioButtonSelectorProductTypesValues =
    RadioButtonSelectorProductTypesValues;

  readonly RadioButtonSelectorProductTypesValues =
    EnumsValues.RadioButtonSelectorProductTypesValues;

  static readonly OrderPaymentType = OrderPaymentType;

  readonly OrderPaymentType = EnumsValues.OrderPaymentType;

  static readonly OrderPaymentReceptionStatus = OrderPaymentReceptionStatus;

  readonly OrderPaymentReceptionStatus =
    EnumsValues.OrderPaymentReceptionStatus;

  static readonly AccountType = AccountType;

  readonly AccountType = EnumsValues.AccountType;

  static readonly AccountStatus = AccountStatus;

  readonly AccountStatus = EnumsValues.AccountStatus;

  static readonly OrdersPageMode = OrdersPageMode;

  readonly OrdersPageMode = EnumsValues.OrdersPageMode;

  static readonly OrderDetailPageMode = OrderDetailPageMode;

  readonly OrderDetailPageMode = EnumsValues.OrderDetailPageMode;
  static readonly SupplierStatus = SupplierStatus;

  readonly SupplierStatus = EnumsValues.SupplierStatus;

  static readonly SupplierLogisticService = SupplierLogisticService;

  readonly SupplierLogisticService = EnumsValues.SupplierLogisticService;

  static readonly LogisticMode = LogisticMode;

  readonly LogisticMode = EnumsValues.LogisticMode;

  static readonly ChairAccountStatus = ChairAccountStatus;

  readonly ChairAccountStatus = EnumsValues.ChairAccountStatus;

  static readonly ExhibitorAccountStatus = ExhibitorAccountStatus;

  readonly ExhibitorAccountStatus = EnumsValues.ExhibitorAccountStatus;

  static readonly OperationAccountInfoMode = OperationAccountInfoMode;

  readonly OperationAccountInfoMode = EnumsValues.OperationAccountInfoMode;

  static readonly IdentificationTypeSelectValue = IdentificationTypeSelectValue;

  readonly IdentificationTypeSelectValue =
    EnumsValues.IdentificationTypeSelectValue;

  static readonly ExportKeys = ExportKeys;

  readonly ExportKeys = EnumsValues.ExportKeys;

  static readonly IdentificationType = IdentificationType;

  readonly IdentificationType = EnumsValues.IdentificationType;

  static readonly WalletRequestType = WalletRequestType;

  readonly WalletRequestType = EnumsValues.WalletRequestType;

  static readonly WalletRequestStatus = WalletRequestStatus;

  readonly WalletRequestStatus = EnumsValues.WalletRequestStatus;

  static readonly Token2FA = Token2FA;

  readonly Token2FA = EnumsValues.Token2FA;

  static readonly Language = Language;

  readonly Language = EnumsValues.Language;

  static readonly CountryDefault = CountryDefault;

  readonly CountryDefault = EnumsValues.CountryDefault;

  static readonly OrdersLogsPageMode = OrdersLogsPageMode;

  readonly OrdersLogsPageMode = EnumsValues.OrdersLogsPageMode;

  static readonly LogActionType = LogActionType;

  readonly LogActionType = EnumsValues.LogActionType;

  static readonly OrderLogisticState = OrderLogisticState;

  readonly OrderLogisticState = EnumsValues.OrderLogisticState;

  static readonly ShopConnectionType = ShopConnectionType;

  readonly ShopConnectionType = EnumsValues.ShopConnectionType;

  static readonly ContainerId = ContainerId;

  readonly ContainerId = EnumsValues.ContainerId;

  static readonly NavePaymentStatus = NavePaymentStatus;

  readonly NavePaymentStatus = EnumsValues.NavePaymentStatus;

  static readonly SettingsDefaultValues = SettingsDefaultValues;

  readonly SettingsDefaultValues = EnumsValues.SettingsDefaultValues;

  static readonly OrderPaymentStatusEnum = OrderPaymentStatusEnum;

  readonly OrderPaymentStatusEnum = EnumsValues.OrderPaymentStatusEnum;

  static readonly ProductStatusesNames = ProductStatusesNames;

  readonly ProductStatusesNames = EnumsValues.ProductStatusesNames;

  static readonly ProductStatusesIds = ProductStatusesIds;

  readonly ProductStatusesIds = EnumsValues.ProductStatusesIds;

  static readonly ProductActionsNames = ProductActionsNames;

  readonly ProductActionsNames = EnumsValues.ProductActionsNames;

  static readonly ProductDetailContentMode = ProductDetailContentMode;

  readonly ProductDetailContentMode = EnumsValues.ProductDetailContentMode;

  static readonly ConstNumbers = ConstNumbers;

  readonly ConstNumbers = EnumsValues.ConstNumbers;

  static readonly CategoriaHito = CategoriaHito;

  readonly CategoriaHito = EnumsValues.CategoriaHito;

  static readonly VigenciaTipo = VigenciaTipo;

  readonly VigenciaTipo = EnumsValues.VigenciaTipo;

  static readonly ImpactoTipo = ImpactoTipo;

  readonly ImpactoTipo = EnumsValues.ImpactoTipo;

  static readonly ContactCountry = ContactCountry;

  readonly ContactCountry = EnumsValues.ContactCountry;

  static readonly ExhibitorFileAction = ExhibitorFileAction;

  readonly ExhibitorFileAction = EnumsValues.ExhibitorFileAction;

  static readonly ContactGender = ContactGender;

  readonly ContactGender = EnumsValues.ContactGender;

  static readonly MemberLeaveReason = MemberLeaveReason;

  readonly MemberLeaveReason = EnumsValues.MemberLeaveReason;

  static readonly ContactGenderToNumber = ContactGenderToNumber;

  readonly ContactGenderToNumber = EnumsValues.ContactGenderToNumber;

  static readonly ContactGenderFromNumber = ContactGenderFromNumber;

  readonly ContactGenderFromNumber = EnumsValues.ContactGenderFromNumber;

  static readonly ProgramVariantScope = ProgramVariantScope;

  readonly ProgramVariantScope = EnumsValues.ProgramVariantScope;

  static readonly ReferredByType = ReferredByType;

  readonly ReferredByType = EnumsValues.ReferredByType;

  static readonly PaymentType = PaymentType;

  readonly PaymentType = EnumsValues.PaymentType;

  constructor(init?: Partial<EnumsValues>) {
    Object.assign(this, init);
  }
}
